export const CampaignTypes = {
	default: 1,
	giveNow: 2,
	appeal: 3,
	bespoke: 4,
	inMemory: 5,
	celebration: 6,
	challenge: 7,
	cycling: 8,
	running: 9,
	event: 10,
	ticketing: 11,
	custom: 12
}